import { Badge } from 'react-bootstrap'
import { defineMessages, useIntl } from 'react-intl'

const COLORS: Record<string, string> = {
  APPROVED: 'success',
  APPROVED_MANUALLY: 'success',
  APPROVED_DISCREPANCY: 'success',
  APPROVED_MANUALLY_DISCREPANCY: 'success',
  NOT_FOUND: 'danger',
}

const LABEL_MESSAGES = defineMessages({
  APPROVED: { id: 'commissions.logs.badge.approved', defaultMessage: 'Approved' },
  APPROVED_MANUALLY: { id: 'commissions.logs.badge.approvedManually', defaultMessage: 'Approved (Manually)' },
  APPROVED_DISCREPANCY: { id: 'commissions.logs.badge.approvedDiscrepancy', defaultMessage: 'Approved (Discrepancy)' },
  APPROVED_MANUALLY_DISCREPANCY: { id: 'commissions.logs.badge.approvedManuallyDiscrepancy', defaultMessage: 'Approved (Manually Discrepancy)' },
  NOT_FOUND: { id: 'commissions.logs.badge.notFound', defaultMessage: 'Not found' },
}) as Record<string, { id: string; defaultMessage: string }>

export const BadgeStatus = ({ state }: { state: string }) => {
  const intl = useIntl()
  const color = COLORS[state] || 'secondary'
  const label = LABEL_MESSAGES[state] ? intl.formatMessage(LABEL_MESSAGES[state]) : state

  return <Badge bg={color}>{label}</Badge>
}
